<template>
  <div ref="container" :class="$style.container">
    <div :class="$style.placeholder"></div>
    <div ref="header" :class="$style.header">
      <div :class="$style.block">
        <div class="flex justify-between mb-8">
          <vs-button :to="backLink" type="border" icon="keyboard_backspace" tag="a">Назад</vs-button>
          <vs-button icon="delete_outline" @click="$emit('delete-all')">Удалить все</vs-button>
        </div>
        <h1 class="mb-2">{{ title }}</h1>
        <div class="mb-8">
          <template v-if="subtitle">
            {{ subtitle }}
          </template>
          <template v-else>
            <span>Подсказка:</span>
            <span :class="$style.hint">
            Введите данные и нажмите Tab
            <app-icon :class="$style.hintIcon" name="KeyTabIcon" />
            или Enter
            <app-icon :class="$style.hintIcon" name="KeyEnterIcon" />.
            <span v-if="focusedField === 'accountNumber' || focusedField === 'paymentType'">
              Для выбора можно использовать кнопки
              <app-icon :class="$style.topIcon" name="ArrowLeftIcon" size="15" /> и
              <app-icon :class="$style.bottomIcon" name="ArrowLeftIcon" size="15" />.
            </span>
            <span v-if="focusedField === 'amount'">Для ввода дробных чисел используйте запятую или точку.</span>
            <span v-if="focusedField === 'monthYear'">Месяц вводить необязательно, система автораспределяет платежи.</span>
            <span v-if="focusedField === 'comment'">Будет создана новая строка. </span>
          </span>
          </template>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name:    "BulkAddHeader",
  props:   ['title', 'subtitle', 'backLink', 'focusedField'],
  data() {
    return {
      lastScrollPosition:  0,
      lastScrollDirection: 'down',
      lastHeaderPosition:  0,
      headerHeight:        0,
      containerOffsetTop:  0,
    };
  },
  methods: {
    setHeaderOffset( offset ) {
      this.$refs.header.style.top = offset + 'px';
      this.lastHeaderPosition = offset;
    },

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.scrollY;
        const offsetTop = scrollTop - this.containerOffsetTop;
        const scrollDirection = this.lastScrollPosition > scrollTop ? 'up' : 'down';

        if (scrollDirection === 'up') {
          if (scrollDirection !== this.lastScrollDirection && this.lastHeaderPosition + this.headerHeight < offsetTop) {
            const top = Math.max(offsetTop - this.headerHeight, 0);
            this.setHeaderOffset(top);
          } else if (offsetTop < this.lastHeaderPosition) {
            const top = Math.max(offsetTop, 0);
            this.setHeaderOffset(top);
          }
        }
        this.lastScrollPosition = scrollTop;
        this.lastScrollDirection = scrollDirection;
      });
    },

    updateLayoutMeasure() {
      this.headerHeight = this.$refs.header.getBoundingClientRect().height;
      this.containerOffsetTop = window.scrollY + this.$refs.container.getBoundingClientRect().top - 15;
    },
  },
  mounted() {
    document.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.updateLayoutMeasure);
    this.updateLayoutMeasure();
  },
  destroyed() {
    document.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.updateLayoutMeasure);
  },
};
</script>

<style lang="scss" module>
$max_width: 1300px;
$header_height: 150px;
$mobile_breakpoint: 1720px;

.placeholder {
  height: $header_height
}

.header {
  position: absolute;
  background: #fff;
  top: 0;
  left: 0;
  width: 100%;
  height: $header_height + 15px;
  //margin-top: -15px;
  z-index: 101;
  transform: translateZ(0);
  //@include max-width(1200px) {
  //  margin-top: -30px;
  //}

  .block {
    padding: 15px;
    padding-right: 0;
    height: 100%;
    @include max-width($mobile_breakpoint) {
      padding-right: 15px;
    }
  }
}

.headerFixed {
  position: fixed;
}

.block {
  max-width: $max_width;
}

.hint {
  opacity: .5;
}

.hintIcon {
  vertical-align: middle;
}

.topIcon {
  vertical-align: middle;
  transform: rotate(90deg);
  width: 12px;
  height: 12px;
}

.bottomIcon {
  vertical-align: middle;
  transform: rotate(-90deg);
}
</style>
